
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#62C4C3","d":"M3 62v-5a6 6 0 016-6h46a6 6 0 016 6v5H3z"}}),_c('path',{attrs:{"fill":"#E0C494","d":"M24 43v8l8 5 8-5v-8z"}}),_c('path',{attrs:{"fill":"#F2DAAE","d":"M44 16v-1H16.211c-.382 0-.759-.036-1.128-.102A17.937 17.937 0 0014 21v8c0 9.941 8.059 18 18 18s18-8.059 18-18v-7a6 6 0 01-6-6z"}}),_c('path',{attrs:{"fill":"#E0C494","d":"M12 22a4 4 0 000 8h2v-8h-2zm40 0h-2v8h2a4 4 0 000-8z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M18 5a2.994 2.994 0 01-2.798-1.941 5.998 5.998 0 00-5.14 6.813c.42 2.989 3.13 5.128 6.149 5.128H44v1a6 6 0 006 6v-1c0-8.836-7.163-16-16-16H18z"}}),_c('path',{attrs:{"fill":"#D36767","d":"M27 40a5 5 0 1110 0H27zM38 2h11l-2 6h3l-8 11V9h-3z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M22.447 29.895l-.894-1.79L25.764 26l-4.211-2.105.894-1.79L30.236 26zM41.553 29.895L33.764 26l7.789-3.895.894 1.79L38.236 26l4.211 2.105z"}})])
          )
        }
      }
    